// Cuándo vuelve a pedir sus listas una pestaña después de que el canal en vivo
// se cortó y se rearmó (un despliegue, un reinicio del servidor, el portátil
// que se durmió). Lo usa `resincronizarEscalonado` en deskte-full.jsx.
//
// POR QUÉ VA REPARTIDO (incidente 2026-10-14): un despliegue corta el canal de
// TODAS las pestañas en el mismo segundo. Cada una vuelve a bajarse la cartera
// entera —en una agencia grande, ~67 páginas de clientes y pólizas— y el
// servidor solo tiene 6 conexiones a la base por copia. Con 45 s de reparto,
// tres despliegues seguidos dejaron 20 minutos de fila y Deskte se quedó en
// "Cargando perfil…". Las listas ligeras (tareas, citas, avisos…) siguen
// rápidas; la CARTERA, que es lo pesado, se reparte en minutos. Mientras tanto
// la pantalla sigue con lo que ya tenía: nada se bloquea, solo tarda un poco
// más en aparecer lo que cambió durante el corte.

/** Hasta cuánto espera una pestaña a la vista antes de pedir las listas ligeras. */
export const MAX_LIGERAS_MS = 45_000;
/** Hasta cuánto espera, ADEMÁS, para la cartera (clientes y pólizas). */
export const MAX_CARTERA_MS = 240_000;
/** Quien vuelve a una pestaña en segundo plano llega a su hora: margen corto. */
export const MAX_LIGERAS_AL_VOLVER_MS = 3_000;
export const MAX_CARTERA_AL_VOLVER_MS = 30_000;

/**
 * Los dos retrasos, en milisegundos: cuándo se piden las listas ligeras y cuándo
 * la cartera (siempre después de las ligeras, nunca antes).
 *
 * @param {{ alVolver?: boolean, azar?: () => number }} op
 *   alVolver: la pestaña estaba en segundo plano y la acaban de mirar.
 *   azar: para las pruebas; por defecto Math.random.
 */
export function retrasosDeResincronizacion({ alVolver = false, azar = Math.random } = {}) {
  const maxLigeras = alVolver ? MAX_LIGERAS_AL_VOLVER_MS : MAX_LIGERAS_MS;
  const maxCartera = alVolver ? MAX_CARTERA_AL_VOLVER_MS : MAX_CARTERA_MS;
  const ligeras = Math.floor(azar() * maxLigeras);
  return { ligeras, cartera: ligeras + Math.floor(azar() * maxCartera) };
}
